import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Header from '../components/Header';
import Marketing from '../components/Marketing';
import Hero from '../components/Hero';
import Social from '../components/Social';

import moment from 'moment';
import useInterval from "../hooks/useInterval";

import { mysqlDatetime, noCacheReq } from '../utilities';
import CardSlider from "../components/CardSlider";
import CardSliderNew from "../components/CardSliderNew";
import { calc4k } from "../utilities";

const settings_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/settings/elevator';
const demo_events_url = 'https://api.asianart.org/wp-json/aam/1.0.0/events/demo';
const alert_url = 'https://api.asianart.org/wp-json/aam/1.0.0/digital-signage/alert';
const events_url = 'https://api.asianart.org/wp-json/aam/1.0.0/events/';

export default function () {

    const [settings,setSettings] = useState(false);
    const [slides, setSlides] = useState( [] );
    const [events,setEvents] = useState([]);
    const [alert,setAlert] = useState({});

    const getTodayEvents = () => {
        const start = new Date();
        const end = new Date();
        start.setHours(0,0,0,0);
        end.setHours(23,59,59,999);
        return noCacheReq( events_url, {
            start: mysqlDatetime( start ),
            end: mysqlDatetime( end ),
            all_info: 1,
        } );
    };

    useEffect( () => {
        Promise.all( [noCacheReq( settings_url ), noCacheReq( demo_events_url ), getTodayEvents()] ).then( data => {
            const settings = data[ 0 ];
            const num_img = settings.num_img;
            let slides_arr = [];
            for( let i = 0; i < num_img; i++ ) {
                slides_arr.push({
                    image: settings[`hero_image-${i}`],
                });
            }

            const events = data[ 2 ];
            let events_arr = [];
            events.forEach( event => {
                const start = new Date(event.start_date);
                const displayTime = moment(start).format('h:mm');
                const displayTimePeriod = moment(start).format('A');

                events_arr.push( {
                    type: event?.type?.name,
                    title: event?.title ? event.title : event?.post_title,
                    location: event?.location_override ? event?.location_override : event?.locations[ 0 ].name,
                    displayTime,
                    displayTimePeriod,
                    startTime: start,
                    img: event['image-sign-thumb'][0]
                } );
            } );

            const today_events = data[2];

            setSlides( slides_arr );
            setEvents( events_arr );
            setSettings( settings );
        } );
    }, [] );

    useInterval(() => {
        noCacheReq(alert_url).then( data => {
            setAlert( data );
        } );
    }, 10000 );

    return settings ? (
        <Container>
            <Header title={settings.section_title}
                    alertSpeed={ alert.alert_speed }
                    alertActive={alert.alert_active}
                    alertMessage={alert.alert_bar_text}
                    alertOnly={true} />
            <Hero slides={slides}
                  duration={settings.hero_slide_duration}
                  size="elevator"
                  vignette={0}/>
            <CardSliderNew
                position="relative"
                title={`Today's events`}
                disableTitlePadding={true}
                offset={false}
                events={events}
                height={ calc4k( 1300 ) }
                noEventsText={ settings.no_events_text }
                currStep={0}
            />
            <Marketing
                title={settings.marketing_panel_title}
                desc={settings.marketing_panel_desc}
                note={settings.marketing_panel_note}
                image={settings.marketing_panel_image}
                height={ calc4k(900) } />
        </Container>
    ) : <Loading><h1>Loading...</h1></Loading>;
}

const Container = styled.div`
   display: flex;
   flex-direction: column;
`;

const Loading = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
`;